import { useFormStore } from "@/widgets/classic-form/form";
import type { Relations } from "@/entities/data-model";
import {
    type FamilyExactnessConfig,
    useFamilyFieldsWithExactnessDisabled,
} from "../shared/useFamilyFieldsWithExactnessDisabled";

const familyRelationsAreExact = (family: Relations, config: FamilyExactnessConfig) =>
    Object.entries(family).every(([relationKey, relation]) => {
        if (!relation.instances.length) return true;
        const givenNameDisabled = config.givenNameDisabled.has(relationKey);
        const surnameDisabled = config.surnameDisabled.has(relationKey);

        return relation.instances.every((instance) => {
            const givenNameExact = givenNameDisabled || instance.givenNameExactness?.isExact;
            const surnameExact = surnameDisabled || instance.surnameExactness?.isExact;
            return givenNameExact && surnameExact;
        });
    });

export const useFamilyExactness = () => {
    const config = useFamilyFieldsWithExactnessDisabled();
    const isExact = useFormStore((store) => familyRelationsAreExact(store.values.family, config));
    return isExact;
};
